import { createSelector } from '@ngrx/store';
import * as RA from 'ramda-adjunct';
import { getMenuState, MenuState } from '../menu.reducer';
import { adapter, LocationSetTypesState } from './location-set-types.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';

const getState = createSelector(getMenuState, (state: MenuState) => state?.locationSetTypes);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getSelectedTag = createSelector(getState, (state: LocationSetTypesState) => state.selectedTag);

const getSelected = createSelector(
    entitySelectors.selectEntities,
    getSelectedTag,
    (entities, selectedTag) => selectedTag && entities[selectedTag]
);

const getOnlyParents = createSelector(entitySelectors.selectAll, (items) =>
    items.filter((item) => item.tag !== 'VENUE')
);

const getValidOnlyParents = createSelector(
    getOnlyParents,
    asyncActionStateSelectors.getHasError,
    asyncActionStateSelectors.getSuccess,
    (items, hasError, success) => (!hasError && success ? items : null)
);

const getIsLocationSetTypeParent = createSelector(
    getSelected,
    (selected) => RA.isNotNull(selected) && selected.tag !== 'LOCATION' && selected.tag !== 'VENUE'
);

const getDisplayResultsImmediately = createSelector(
    getSelected,
    (selected) => RA.isNonEmptyString(selected?.tag) && selected.tag !== 'LOCATION'
);

export const LocationSetTypesSelectors = {
    entitySelectors,
    ...asyncActionStateSelectors,
    getSelectedTag,
    getSelected,
    getOnlyParents,
    getValidOnlyParents,
    getIsLocationSetTypeParent,
    getDisplayResultsImmediately,
};
